import { useEffect, useState } from 'preact/hooks'
import type { Dispatch, StateUpdater } from 'preact/hooks'
import { websApi, type WebViewDto } from '@/api/webs'
import { useToast } from '@/hooks/useToast'

interface UseWebLoaderResult {
    web: WebViewDto | null
    setWeb: Dispatch<StateUpdater<WebViewDto | null>>
    loading: boolean
    error: string | null
}

export function useWebLoader(workspaceId: string, webId: string): UseWebLoaderResult {
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)
    const [web, setWeb] = useState<WebViewDto | null>(null)
    const { showError } = useToast()

    useEffect(() => {
        let active = true;
        (async () => {
            setLoading(true)
            setError(null)
            const res = await websApi.getById(workspaceId, webId)
            if (!active) return
            if (res.data) setWeb(res.data)
            else {
                const message = res.error || 'Failed to load web details'
                setError(message)
                showError('Load failed', message)
            }
            setLoading(false)
        })()
        return () => { active = false }
    }, [workspaceId, webId])

    return { web, setWeb, loading, error }
}
